export default __webpack_public_path__ + "static/media/KDS_Mobile1.0d7a5d4e.svg";